import { useMemo, useState } from "react";
import { CAT_CAPABILITIES, CAT_ENGAGEMENT_TERMS, CAT_FOCUS_CATEGORY } from "../../constants/constants";
import FocusCategory from "./Profile/FocusCategory";
import Capabilities from "./Profile/Capabilities";
import EngagementTerms from "./Profile/EngagementTerms";

interface Props {
    data: any
}
const PartnerMarketDetails = (props: Props) => {
    const { data } = props;

    const [activeTab, setActiveTab] = useState(CAT_FOCUS_CATEGORY)


    const content = useMemo(() => {
        switch (activeTab) {
            case CAT_FOCUS_CATEGORY:
                return <FocusCategory data={data?.categories || []} />
            case CAT_CAPABILITIES:
                return <Capabilities data={data} />
            case CAT_ENGAGEMENT_TERMS:
                return <EngagementTerms data={data} />

            default:
                return <></>
        }
    }, [
        activeTab, data
    ])

    return (
        <div className="w-full flex border-t border-[#E4E7EC]">
            <div className='flex flex-col gap-y-[6px] overflow-auto w-[180px] border-r border-[#E4E7EC] pr-[10px] pt-[10px]'>
                <div className={`${activeTab === CAT_FOCUS_CATEGORY ? "!bg-[#D1E9FF]" : ""} hover:bg-[#EFF8FF] transition-colors duration-200 flex items-center justify-between px-[10px] py-[6px] rounded-[4px] cursor-pointer`} onClick={() => {
                    setActiveTab(CAT_FOCUS_CATEGORY)
                }}>
                    <p className={`${activeTab === CAT_FOCUS_CATEGORY ? "text-[#1849A9]" : ""} text-[13px] font-[500] m-0`}>Focus Category</p>
                </div>
                <div className={`${activeTab === CAT_CAPABILITIES ? "!bg-[#D1E9FF]" : ""} hover:bg-[#EFF8FF] transition-colors duration-200 flex items-center justify-between px-[10px] py-[6px] rounded-[4px] cursor-pointer`} onClick={() => {
                    setActiveTab(CAT_CAPABILITIES)
                }}>
                    <p className={`${activeTab === CAT_CAPABILITIES ? "text-[#1849A9]" : ""} text-[13px] font-[500] m-0`}>Channel & Capabilities</p>
                </div>
                <div className={`${activeTab === CAT_ENGAGEMENT_TERMS ? "!bg-[#D1E9FF]" : ""} hover:bg-[#EFF8FF] transition-colors duration-200 flex items-center justify-between px-[10px] py-[6px] rounded-[4px] cursor-pointer`} onClick={() => {
                    setActiveTab(CAT_ENGAGEMENT_TERMS)
                }}>
                    <p className={`${activeTab === CAT_ENGAGEMENT_TERMS ? "text-[#1849A9]" : ""} text-[13px] font-[500] m-0`}>Engagement Terms</p>
                </div>
            </div>
            <div className="flex-1 p-[16px]">
                {content}
            </div>
        </div>
    )
}

export default PartnerMarketDetails